module.exports = __webpack_public_path__ + "img/Pipeline_W.64229942.png";